(() => {
  const messages = JSON.parse(document.getElementById('sa-ui-messages')?.textContent || '{}');
  document.querySelectorAll('.sa-footer-group > summary,.sa-faq-row > summary').forEach(summary => {
    summary.addEventListener('keydown', event => {
      if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); summary.parentElement.open = !summary.parentElement.open; }
    });
  });
  const dialog = document.getElementById('sa-privacy-dialog'), banner = document.getElementById('sa-cookie-banner'), status = document.getElementById('sa-privacy-status');
  if (!dialog) return;
  let api, ready;
  const gpc = navigator.globalPrivacyControl === true;
  const ids = {preferences:'sa-consent-preferences',analytics:'sa-consent-analytics',marketing:'sa-consent-marketing',sale_of_data:'sa-consent-sale'};
  const loadApi = () => {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (ready) return ready;
    ready = new Promise((resolve,reject) => {
      let tries = 0;
      const attempt = () => {
        if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error => error ? reject(error) : resolve(window.Shopify.customerPrivacy));
        else if (++tries < 40) setTimeout(attempt,250); else reject(new Error('Privacy API unavailable'));
      }; attempt();
    }).catch(error => { ready = null; throw error; });
    return ready;
  };
  const update = cp => {
    const current = cp.currentVisitorConsent();
    Object.entries(ids).forEach(([key,id]) => { const input=document.getElementById(id); input.checked=current[key] === 'yes'; if (gpc && ['marketing','sale_of_data'].includes(key)) {input.checked=false;input.disabled=true;} });
    document.getElementById('sa-gpc-notice').hidden = !gpc;
  };
  const open = async () => {
    status.textContent = ''; if (!dialog.open) dialog.showModal();
    try { api=await loadApi(); update(api); } catch {status.textContent=messages.privacy_error;}
  };
  const save = async values => {
    status.textContent='';
    if (gpc) {values.marketing=false;values.sale_of_data=false;}
    try {
      api=await loadApi();
      await new Promise((resolve,reject) => api.setTrackingConsent(values,error => error ? reject(error) : resolve()));
      update(api); try {localStorage.setItem('sa-privacy-choice','saved');} catch {}
      banner.hidden=true; status.textContent=messages.privacy_saved;
      if (dialog.open) dialog.close();
    } catch {if (!dialog.open) dialog.showModal();status.textContent=messages.privacy_error;}
  };
  document.querySelectorAll('[data-sa-privacy-open]').forEach(button => button.addEventListener('click',open));
  document.querySelector('[data-sa-privacy-close]').addEventListener('click',() => dialog.close());
  document.querySelectorAll('[data-sa-privacy-reject]').forEach(button => button.addEventListener('click',() => save({preferences:false,analytics:false,marketing:false,sale_of_data:false})));
  document.querySelectorAll('[data-sa-privacy-accept]').forEach(button => button.addEventListener('click',() => save({preferences:true,analytics:true,marketing:!gpc,sale_of_data:!gpc})));
  document.querySelector('[data-sa-privacy-save]').addEventListener('click',() => save(Object.fromEntries(Object.entries(ids).map(([key,id]) => [key,document.getElementById(id).checked]))));
  loadApi().then(cp => { api=cp;update(cp); const current=cp.currentVisitorConsent(); let seen=false;try{seen=localStorage.getItem('sa-privacy-choice')==='saved';}catch{} if (!seen && Object.values(current).every(v => v === '')) banner.hidden=false; }).catch(() => {});
})();
